import React, { useState, useEffect } from 'react';
import { api } from '../../utils/api';

const FAQPanel = () => {
  const [faqs, setFaqs] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [current, setCurrent] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      const data = await api.getFAQs();
      setFaqs(data);
    } catch (err) {
      console.error('Failed to load:', err);
    }
  };

  const handleNew = () => {
    setCurrent({ question: '', answer: '', order: 0 });
    setIsEditing(true);
  };

  const handleEdit = (item) => {
    setCurrent(item);
    setIsEditing(true);
  };

  const handleSave = async () => {
    try {
      if (current.id) {
        await api.updateFAQ(current.id, current);
      } else {
        await api.createFAQ(current);
      }
      setMessage('FAQ saved!');
      setIsEditing(false);
      load();
    } catch (err) {
      setMessage('Failed to save: ' + err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this FAQ?')) return;
    try {
      await api.deleteFAQ(id);
      load();
    } catch (err) {
      alert('Failed to delete: ' + err.message);
    }
  };

  if (isEditing) {
    return (
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h2 className="text-2xl font-bold">{current.id ? 'Edit' : 'New'} FAQ</h2>
          <button onClick={() => setIsEditing(false)} className="px-4 py-2 text-sm border border-gray-300 rounded hover:bg-gray-50">Cancel</button>
        </div>

        {message && <div className={`p-4 rounded ${message.includes('success') || message.includes('saved') ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}`}>{message}</div>}

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-2">Question</label>
            <input type="text" value={current.question} onChange={(e) => setCurrent({ ...current, question: e.target.value })} className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-black" />
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Answer</label>
            <textarea value={current.answer} onChange={(e) => setCurrent({ ...current, answer: e.target.value })} rows={4} className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-black" />
          </div>

          <button onClick={handleSave} className="px-6 py-2 bg-black text-white rounded hover:bg-gray-800 transition-colors">Save FAQ</button>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">FAQs</h2>
        <button onClick={handleNew} className="px-4 py-2 bg-black text-white rounded hover:bg-gray-800 transition-colors">+ New FAQ</button>
      </div>

      <div className="space-y-4">
        {faqs.map((item) => (
          <div key={item.id} className="p-4 border border-gray-200 rounded-lg">
            <p className="font-medium text-gray-900 mb-2">{item.question}</p>
            <p className="text-sm text-gray-600">{item.answer}</p>
            <div className="mt-3 flex gap-2">
              <button onClick={() => handleEdit(item)} className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50">Edit</button>
              <button onClick={() => handleDelete(item.id)} className="px-3 py-1 text-sm text-red-600 border border-red-300 rounded hover:bg-red-50">Delete</button>
            </div>
          </div>
        ))}
      </div>

      {faqs.length === 0 && <div className="text-center py-12 text-gray-500">No FAQs yet.</div>}
    </div>
  );
};

export default FAQPanel;
